import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { parcelDirections } from '@/parcels/constants'
import { parcelTabs } from '@/parcels/pages/ParcelsPage/constants'

const useParcelTab = ({ allowsOutbound, allowsShipments } = {}) => {
  const navigate = useNavigate()

  const showOutbound = allowsOutbound || allowsShipments

  const getParcelTab = () => {
    if (!showOutbound) return parcelDirections.inbound

    return localStorage.getItem('parcelTab') || parcelDirections.outbound
  }

  const getVisibleTabs = () => {
    if (!showOutbound) return parcelTabs.filter(tab => tab.value === parcelDirections.inbound)

    return parcelTabs
  }

  const handleTabChange = useCallback(
    tab => {
      localStorage.setItem('parcelTab', tab)
      navigate(tab)
    },
    [navigate]
  )

  return { parcelTab: getParcelTab(), visibleTabs: getVisibleTabs(), handleTabChange }
}

export default useParcelTab
